var _defs, _rect, _rect2, _g, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgObsidianGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1280,
    y2: 720,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030712"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 68,
    width: 1104,
    height: 584,
    rx: 34,
    fill: "#0F172A",
    fillOpacity: 0.72,
    stroke: "#334155",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 68V652",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 146H1192",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 252H1192",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 358H1192",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 464H1192",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 570H1192",
    stroke: "#64748B",
    strokeWidth: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1052,
    cy: 154,
    r: 82,
    fill: "#38BDF8",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 560,
    r: 108,
    fill: "#A78BFA",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgObsidianGrid);
export default __webpack_public_path__ + "static/media/bg-obsidian-grid.c5b199741a8b485f5447504da034ea31.svg";
export { ForwardRef as ReactComponent };